import { Button } from '@mui/material';
import PropTypes from 'prop-types';
export const userTableColumns = (
  handleOpenUserDetails,
  handleOpenDeleteUser
) => [
  {
    accessorKey: 'id',
    header: 'ID',
    enableSorting: true,
    filterVariant: 'textField',
    enableColumnFilter: true,
  },
  {
    accessorKey: 'firstName',
    header: 'First Name',
    enableSorting: true,
    filterVariant: 'textField',
    enableColumnFilter: true,
  },
  {
    accessorKey: 'lastName',
    header: 'Last Name',
    enableSorting: true,
    filterVariant: 'textField',
    enableColumnFilter: true,
  },
  {
    accessorKey: 'username',
    header: 'Username',
    enableSorting: true,
    filterVariant: 'textField',
    enableColumnFilter: true,
  },
  {
    accessorKey: 'details',
    header: 'Details',
    enableSorting: false,
    enableColumnFilter: false,
    enableFacetedValues: false,
    Cell: ({ renderedCellValue }) => {
      return detailsCell({ renderedCellValue, handleOpenUserDetails });
    },
  },
  {
    accessorKey: 'delete',
    header: 'Delete',
    enableSorting: false,
    enableColumnFilter: false,
    enableFacetedValues: false,
    Cell: ({ renderedCellValue }) => {
      return deleteCell({ renderedCellValue, handleOpenDeleteUser });
    },
  },
];

//! Language
const detailsCell = ({ renderedCellValue, handleOpenUserDetails }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={() => {
        handleOpenUserDetails(renderedCellValue);
      }}>
      Details
    </Button>
  );
};

detailsCell.propTypes = {
  renderedCellValue: PropTypes.object.isRequired,
  handleOpenUserDetails: PropTypes.func.isRequired,
};

const deleteCell = ({ renderedCellValue, handleOpenDeleteUser }) => {
  return (
    <Button
      variant="contained"
      color="secondary"
      onClick={() => {
        handleOpenDeleteUser(renderedCellValue);
      }}>
      Delete
    </Button>
  );
};

deleteCell.propTypes = {
  renderedCellValue: PropTypes.object.isRequired,
  handleOpenDeleteUser: PropTypes.func.isRequired,
};
